// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import { type RedirectUrl, RedirectUrlFromJSON, RedirectUrlToJSON } from "../models/RedirectUrl";
import {
  type SubscriptionRequest,
  SubscriptionRequestFromJSON,
  SubscriptionRequestToJSON,
} from "../models/SubscriptionRequest";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface ClearlyHubProcessSubscriptionRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  subscriptionRequest: SubscriptionRequest;
}

export interface ClearlyHubSubscriptionRedirectRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  next: string;
}

/**
 *
 */
export class ClearlyHubIntegrationApi extends runtime.BaseAPI {
  /**
   * Creates request options for clearlyHubProcessSubscription without sending the request
   */
  async clearlyHubProcessSubscriptionRequestOpts(
    requestParameters: ClearlyHubProcessSubscriptionRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling clearlyHubProcessSubscription().'
      );
    }

    if (requestParameters["subscriptionRequest"] == null) {
      throw new runtime.RequiredError(
        "subscriptionRequest",
        'Required parameter "subscriptionRequest" was null or undefined when calling clearlyHubProcessSubscription().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/clearly-hub-integration/subscription`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SubscriptionRequestToJSON(requestParameters["subscriptionRequest"]),
    };
  }

  /**
   * Results in a user being created, or an PermissionDeni.
   * process a subscription retrieved from the subscription flow
   */
  async clearlyHubProcessSubscriptionRaw(
    requestParameters: ClearlyHubProcessSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.clearlyHubProcessSubscriptionRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Results in a user being created, or an PermissionDeni.
   * process a subscription retrieved from the subscription flow
   */
  async clearlyHubProcessSubscription(
    requestParameters: ClearlyHubProcessSubscriptionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.clearlyHubProcessSubscriptionRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for clearlyHubSubscriptionRedirect without sending the request
   */
  async clearlyHubSubscriptionRedirectRequestOpts(
    requestParameters: ClearlyHubSubscriptionRedirectRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling clearlyHubSubscriptionRedirect().'
      );
    }

    if (requestParameters["next"] == null) {
      throw new runtime.RequiredError(
        "next",
        'Required parameter "next" was null or undefined when calling clearlyHubSubscriptionRedirect().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["next"] != null) {
      queryParameters["next"] = requestParameters["next"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/clearly-hub-integration/subscription`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a url to redirect the user to.
   * generate a redirect url for the subscription flow
   */
  async clearlyHubSubscriptionRedirectRaw(
    requestParameters: ClearlyHubSubscriptionRedirectRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RedirectUrl>> {
    const requestOptions = await this.clearlyHubSubscriptionRedirectRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => RedirectUrlFromJSON(jsonValue));
  }

  /**
   * Return a url to redirect the user to.
   * generate a redirect url for the subscription flow
   */
  async clearlyHubSubscriptionRedirect(
    requestParameters: ClearlyHubSubscriptionRedirectRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RedirectUrl> {
    const response = await this.clearlyHubSubscriptionRedirectRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
